'use client'

import { useTranslations } from 'next-intl'

export function SkipToContentLink() {
  const t = useTranslations('Common')

  return (
    <a
      className="sr-only focus:not-sr-only focus:fixed focus:start-4 focus:top-4 focus:z-[99999] focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-primary-foreground"
      href="#main-content"
    >
      {t('skipToContent')}
    </a>
  )
}
